import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=055b9966&scoped=true&"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=055b9966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b9966",
  null
  
)

export default component.exports